const boolDP = process.env.NODE_ENV !== 'development'
/*
    @author : Suraj Chavan,
    @params : Accept default option {} , 
    @description : This function accepts a object option and return onother function,
                which again accepts object as option argument and combine both object 
                and return a fetch request promise
    @return : Return a function which accept another option
*/
export const request = defaults => (obj) => options => {
    const store = (obj||{}).store;
    const isLoaderEnabled = options.loader == null ? true : options.loader;
    delete options.loader;
    isLoaderEnabled && store && store.commit && store.commit("loading", true);
    options.headers = Object.assign({}, defaults.headers, options.headers);
    options = Object.assign({}, defaults, options)
    let isBlob = (options.blob || false) && delete options.blob;
    return fetch(options.url, options)
        .then(resp => {
            if (resp.status === 401) {
                alert("Invalid session");
                return boolDP ? (location.href = "/", sessionStorage.clear()) : ''
            }
            if(resp.status !== 200)
                throw new Error("Some thing unexpected happened, server response code "+resp.status);
            isLoaderEnabled && store && store.commit && store.commit("loading", false);
            if (isBlob) return resp.blob();
            return resp.json();
        })
        .catch((error) => { 
            isLoaderEnabled && store && store.commit && store.commit("loading", false);
            console.error("request ", error.message)
            return {status: 'unsuccess', error: error.message}
        })
}

// defaulting
export const createRequester = request({
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        'sessionid': sessionStorage.getItem("_ticket")
    }
})